export const SCOPES = {
  ROTA_ADMIN_READ: 'rota:admin-read',
  ROTA_COST_READ: 'rota:cost-read',
};

/**
 * Check whether the current user has a specific scope.
 * @param {Object} user  – user object from the store (must contain `scopes` array)
 * @param {string} scope – scope string, e.g. 'events:write'
 * @returns {boolean}
 */
export function hasScope(user, scope) {
  return Array.isArray(user?.scopes) && user.scopes.includes(scope);
}
